<template>
    <div>
        <autocomplete-input
                placeholder="Search"
                v-model="searchQuery"
                suggest-method="searchSuggest"
                @input="search" />
    </div>
</template>

<script>
    import AutocompleteInput from "./AutocompleteInput";

    export default {
        components: {AutocompleteInput},
        name: '',
        data() {
            return {
                searchQuery: ''
            }
        },

        methods: {

            search(input){
                this.$router.push({name:'Search', params:{query: this.searchQuery}});
            },



        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/ui/SearchField.vue